import { Col, Form, Modal, Row } from "antd";
import React, { Fragment, useCallback } from "react";
import update from "immer";
import moment from "moment";

import BienKSXe from "../conponents/BienKSXe";
import ChiNhanhXe from "../conponents/ChiNhanhXe";
import Customer from "../conponents/Customer";
import KeToan from "../conponents/KeToan";
import SoHopDong from "../conponents/SoHopDong";
import LoaiHopDong from "../conponents/LoaiHopDong";
import AdminDieuHanh from "../conponents/AdminDieuHanh";
import TrangThaiHopDong from "../conponents/TrangThaiHopDong";
import SelectDate from "../conponents/SelectDate";

const BusinessReportModal = ({ onCancel, onOk, visible }) => {
  const [form] = Form.useForm();

  const handleClickOk = useCallback(() => {
    const filter = update(form.getFieldsValue(), (draf) => {
      draf.contract_type =
        draf.contract_type.id === "all" ? null : draf.contract_type;

      draf.vehicle.branch =
        draf.vehicle.branch.code === "all" ? null : draf.vehicle.branch;

      draf.sign_date_lte = draf.sign_date_lte
        ? draf.sign_date_lte
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x")
        : moment()
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x");

      draf.sign_date_gte = draf.sign_date_gte
        ? draf.sign_date_gte
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x")
        : 0;
    });

    const query = {
      filter,
      page: 1,
      size: 1000000,
    };

    if (!!onOk) {
      form.resetFields();
      onOk(query);
    }
  }, [onOk, form]);

  const handleCancel = useCallback(() => {
    !!onCancel && onCancel();
    form.resetFields();
  }, [onCancel, form]);

  return (
    <Modal
      onCancel={handleCancel}
      onOk={handleClickOk}
      width={900}
      title="Chọn tham số lọc báo cáo Kinh doanh dài  hạn"
      visible={visible}
      okText="Lọc báo cáo"
      cancelText="Huỷ"
    >
      <Form
        labelAlign="left"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        form={form}
        initialValues={{
          contract_type: {
            id: "all",
          },
          customer: {
            id_in: null,
          },
          prefix_code_in: null,
          sign_date_gte: 0,
          sign_date_lte: 0,
          vehicle: {
            accountant: {
              id_in: null,
            },
            branch: {
              code: "all", // chi nhánh xe
            },
            id_in: null,
            operation_admin: {
              id_in: null,
            },
          },
          vehicle_is_transferred_another: null,
          status: null,
          driver_is_transferred_another: null,
        }}
      >
        <SelectDate setFieldsValue={form.setFieldsValue} />

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item label="Biển KS xe" name={["vehicle", "id_in"]}>
              <BienKSXe setFieldsValue={form.setFieldsValue} name="vehicle" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Khách hàng" name="customer">
              <Customer setFieldsValue={form.setFieldsValue} name="customer" />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              label="Chi nhánh xe"
              name={["vehicle", "branch", "code"]}
            >
              <ChiNhanhXe
                setFieldsValue={form.setFieldsValue}
                name="code"
                value={form.getFieldValue(["vehicle", "branch", "code"])}
              />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Số hợp đồng" name="prefix_code_in">
              <SoHopDong
                setFieldsValue={form.setFieldsValue}
                name="prefix_code_in"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item label="Kế toán" name={["vehicle", "accountant"]}>
              <KeToan setFieldsValue={form.setFieldsValue} name="accountant" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Loại hợp đồng" name={["contract_type", "id"]}>
              <LoaiHopDong
                setFieldsValue={form.setFieldsValue}
                name="contract_type"
                value={form.getFieldValue(["contract_type", "id"])}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              label="Admin điều hành"
              name={["vehicle", "operation_admin"]}
            >
              <AdminDieuHanh
                setFieldsValue={form.setFieldsValue}
                name="operation_admin"
              />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Trạng thái HĐ">
              <TrangThaiHopDong setFieldsValue={form.setFieldsValue} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          style={{ display: "none" }}
          name="vehicle_is_transferred_another"
        >
          <Fragment />
        </Form.Item>

        <Form.Item
          style={{ display: "none" }}
          name="driver_is_transferred_another"
        >
          <Fragment />
        </Form.Item>

        <Form.Item style={{ display: "none" }} name="status">
          <Fragment />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BusinessReportModal;
